import { apiFetch, withAuth } from "../common/api";

const HOST = import.meta.env.VITE_API_HOST;

/**
 * @param {object} accessToken
 * @returns {Promise<Array<HolidayYear>>}
 */
export async function fetchAll(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/holidays`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }

  const data = await resp.json();
  console.log("Fetched", data, "holidays");
  return data;
}

/**
 * @param {object} accessToken
 * @param {HolidayYear} req
 * @throws {string}
 */
export async function save(accessToken, req) {
  const currentYear = new Date().getFullYear();
  const maxYear = currentYear + 50;

  if (req.year < currentYear) {
    throw `Нельзя импортировать праздники на прошедшие годы. Минимальный год: ${currentYear}`;
  }

  if (req.year > maxYear) {
    throw `Нельзя импортировать праздники на год позже ${maxYear}`;
  }

  const opts = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  const resp = await apiFetch(
    `${HOST}/api/v1/holidays`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
}
